import React from 'react';
import classNames from 'classnames';
import { ProgressBar } from 'react-bootstrap';

/**
 * @param {number} totalSteps   — nombre total d’étapes (5 ou 6)
 * @param {number} currentStep  — index de l’étape active (0)
 */
function RegisterProgress({ totalSteps = 6, currentStep = 0 }) {
  // Choix de la classe de base en fonction du total d’étapes
  const stepClass = totalSteps === 6 ? 'six-steps' : 'five-steps';
  const steps = Array.from({ length: totalSteps }, (_, i) => i);
  const percent = Math.round((currentStep / (totalSteps)) * 100);

  return (
    <>
      {/* Desktop / tablette */}
      <div className="register-progress-container hide-tablet hide-mobile">
        <ul>
          {steps.map(i => (
            <li
              key={i}
              className={classNames(stepClass, {
                stepwithtruck: i === currentStep - 1,
              })}
            />
          ))}
        </ul>
        <ProgressBar
          className="register-progress-barre"
          now={percent}
        />
      </div>

      {/* Mobile only : active forme */}
      <div className="register-progress-mobile hide-desktop">
        <ul>
          {steps.map(i => (
            <li
              key={i}
              className={classNames(stepClass, {
                'active': i === currentStep - 1,
              })}
            />
          ))}
        </ul>
      </div>
    </>
  );
}

export default RegisterProgress;
